module.exports = __webpack_public_path__ + "static/img/logo_red_business.5f6dbd31.png";